// This turns a list of new hook interfaces and previous hook interfaces into a list of operations.
// It used to be nice and functional, but it wasn't extra readable, so I let chatgpt turn it into ugly for loops which are admittedly more clear.
export const makeOperations = <A, B>(
  currentHookInterfaces: A[],
  upstreamHookInterfaces: B[],
  eq: (a: A, b: B) => boolean
) => {
  const results: Array<
    | { type: 'patch'; current: A; upstream: B }
    | { type: 'delete'; current: A; upstream: undefined }
    | { type: 'create'; current: undefined; upstream: B }
  > = [];

  for (const current of currentHookInterfaces) {
    const upstream = upstreamHookInterfaces.find(u => eq(current, u));
    if (upstream) {
      results.push({ type: 'patch', current, upstream });
    } else {
      results.push({ type: 'delete', current, upstream: undefined });
    }
  }

  for (const upstream of upstreamHookInterfaces) {
    const exists = currentHookInterfaces.some(c => eq(c, upstream));
    if (!exists) {
      results.push({ type: 'create', current: undefined, upstream });
    }
  }

  return results;
};
